<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useMediaQuery } from '@vueuse/core'
import Avatar from '../Avatar/Avatar.vue'
import { cn } from '@/lib/utils'
import aiIcon from '@/assets/ai-icon.svg'
import { getSvgCSS } from '@/utils'

const props = defineProps<{ visible: boolean, close: () => void }>()

const isSmallScreen = useMediaQuery('(min-width: 600px)')

const aiIconCss = ref<string>()

onMounted(async () => {
  aiIconCss.value = await getSvgCSS(aiIcon)
})
</script>

<template>
  <div
    :class="cn(
      'header-container',
      $attrs.class ?? '',
    )"
  >
    <div
      :class="cn(
        'header-wrapper',
      )"
    >
      <div>
        <div
          :class="cn(
            'header',
            props.visible === true ? 'fade-enter-done' : '',
          )"
        >
          <div>
            <nav class="header-nav">
              <div class="header-nav-content">
                <!-- <div class="header-action-button-container">
                  <button type="button" aria-label="go back" class="header-action-button" tabindex="0">
                    <div
                      class="i-ph-caret-left-bold text-xl"
                    />
                  </button>
                </div> -->
                <button class="header-button" tabindex="0">
                  <Avatar />
                  <h1 class="header-title">
                    Beeetle
                  </h1>
                  <div class="header-subtitle">
                    <div :style="aiIconCss" />
                    Bot
                  </div>
                </button>
                <div class="header-end">
                  <div v-if="!isSmallScreen" aria-label="Close" :aria-hidden="!isSmallScreen" role="button" class="header-action-button" @click="props.close">
                    <div class="i-ph-x-bold" />
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

